<ion-content>
  <div class="constrained-content">
    <ion-grid class="constrained-content">
      <ion-row>
        <ion-col size-md="4" size="12" class="settings-title-section">
          <h1><ion-icon name="pulse-outline"></ion-icon>Statuses</h1>
          <p class="subtitle">
            Define custom statuses for conversations to better track their
            progress through your workflow.
          </p>
          <!-- <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <a href="https://docs.unthread.io/conversations/custom-statuses" target="_blank">
              Learn more about custom statuses
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
          </p> -->
        </ion-col>
        <ion-col size-md="8" size="12">
          <ng-container *ngFor="let statusType of statusTypes">
            <ng-container
              *ngIf="
                groupedSubStatuses[statusType] &&
                groupedSubStatuses[statusType].length > 0
              "
            >
              <div class="inline-flexed-align-center">
                <h2 class="status-type-header">
                  <ion-icon
                    [name]="STATUS_COLUMN_FORMAT_MAP[statusType].icon"
                    [class]="STATUS_COLUMN_FORMAT_MAP[statusType].iconClass"
                  ></ion-icon>
                  {{ typeLabels[statusType] }}
                </h2>
                <ion-button
                  (click)="createSubStatus(statusType)"
                  fill="clear"
                  size="small"
                >
                  <ion-icon
                    name="add-circle-outline"
                    class="padded-icon"
                  ></ion-icon>
                  Add sub-status
                </ion-button>
              </div>

              <ion-card class="outline-card" style="margin: 18px">
                <ngx-datatable
                  class="material fullscreen"
                  [columnMode]="ColumnMode.force"
                  [limit]="100"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="46"
                  [rows]="groupedSubStatuses[statusType]"
                  [reorderable]="true"
                  [messages]="{
                    emptyMessage: 'No statuses found for this type.',
                    totalMessage: 'total'
                  }"
                >
                  <ngx-datatable-column
                    name="Name"
                    prop="name"
                    [minWidth]="100"
                    [sortable]="false"
                  >
                    <ng-template
                      let-value="value"
                      let-row="row"
                      ngx-datatable-cell-template
                    >
                      <a
                        class="row-title row-link"
                        (click)="editSubStatus(row.id)"
                        >{{ value }}</a
                      >
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column
                    name="Description"
                    prop="description"
                    [minWidth]="200"
                    [sortable]="false"
                  >
                    <ng-template
                      let-value="value"
                      let-row="row"
                      ngx-datatable-cell-template
                    >
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column
                    name=""
                    [sortable]="false"
                    [minWidth]="100"
                    [maxWidth]="100"
                  >
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <ion-button
                        fill="clear"
                        size="small"
                        (click)="moveUp(row)"
                        [disabled]="row.position <= 0"
                        class="move-button"
                      >
                        <ion-icon name="arrow-up-outline"></ion-icon>
                      </ion-button>
                      <ion-button
                        fill="clear"
                        size="small"
                        (click)="moveDown(row)"
                        [disabled]="
                          row.position >=
                          groupedSubStatuses[statusType].length - 1
                        "
                        class="move-button"
                      >
                        <ion-icon name="arrow-down-outline"></ion-icon>
                      </ion-button>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </ion-card>
            </ng-container>
          </ng-container>
          <div
            *ngIf="filteredSubStatuses.length === 0 && !isLoading"
            class="empty-state"
          >
            No statuses found.
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
